import { useEffect, useState } from 'react'

import { AgencyV2ClientPageLayout } from 'components/layouts/AgencyV2ClientPageLayout'
import { useParams } from 'react-router-dom'

import BillboardUploader from '../BillboardUploader'

enum AgencyV2UploadBillboardStep {
  Upload = 'upload',
}

interface CreateAdBillboardsRetailPageParams {
  step: string
}

export const AgencyV2CreateAdBillboardsRetailPage = () => {
  const { step } = useParams<CreateAdBillboardsRetailPageParams>()
  const [helmetTitle, setHelmetTitle] = useState('')
  const [panelTitle, setPanelTitle] = useState('')

  useEffect(() => {
    switch (step) {
      case AgencyV2UploadBillboardStep.Upload:
        setHelmetTitle('Upload Billboard')
        setPanelTitle('Upload Billboard')
        break
    }
  }, [step])

  return (
    <AgencyV2ClientPageLayout helmetTitle={helmetTitle} panelTitle={panelTitle}>
      {step === AgencyV2UploadBillboardStep.Upload && <BillboardUploader />}
    </AgencyV2ClientPageLayout>
  )
}
